import { render, staticRenderFns } from "./NuevaReceta.vue?vue&type=template&id=4d060ac4&scoped=true"
import script from "./NuevaReceta.vue?vue&type=script&lang=js"
export * from "./NuevaReceta.vue?vue&type=script&lang=js"
import style0 from "./NuevaReceta.vue?vue&type=style&index=0&id=4d060ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d060ac4",
  null
  
)

export default component.exports